import { useEffect, useState } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";
registerLocale("es", es);
registerLocale("fr", fr);
registerLocale("de", de);

const DatepickerEntry = (props) => {
  const { item, OnDateChange } = props;
  const { language } = useLanguageContext();
  const [defaultDate, setDefaultDate] = useState(null);

  useEffect(() => {
    let defaultvalue = null;
    if (
      item.value !== null &&
      item.value !== undefined &&
      item.value !== "" &&
      item.value !== " "
    ) {
      if (item.value.includes(".")) {
        const splitdate = item.value.toString().split(".");
        defaultvalue = new Date(
          Number(splitdate[2]),
          Number(splitdate[1]),
          Number(splitdate[0]),
        );
      } else if (!item.value.includes("-")) {
        defaultvalue = new Date(item.value.toString());
      }
    }
    setDefaultDate(defaultvalue);
  }, [item]);

  return (
    <div className="form-group" key={item.standardAttributId}>
      <label className="" style={{ width: "100%" }}>
        {item.bezeichnung}
        {item.mandatoryField ? (
          <>
            <span className="requiredCls"></span>
          </>
        ) : (
          <></>
        )}
      </label>

      <DatePicker
        className="form-control"
        selected={defaultDate}
        disabled={!item.editbarFeld}
        onChange={(date) => {
          setDefaultDate(date);
          OnDateChange(
            date.toLocaleDateString(
              language.toLowerCase() + "-" + language.toUpperCase(),
            ),
            item.bezeichnung,
          );
        }}
        locale={language}
        dateFormat="dd.MM.yyyy"
      />
    </div>
  );
};
export default DatepickerEntry;
